/* @generated */

// ../src/truncate/truncate.tsx
import * as React2 from "react";
import { useDebouncedCallback, useResizeObserver } from "@react-hookz/web";
import { Tooltip } from "@dropbox/dig-components/tooltips";
import classNames from "classnames";

// ../src/truncate/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var truncate = "dig-hp95xv0_21-7-0";
var truncateInner = _7a468({ defaultClassName: "dig-hp95xv1_21-7-0", variantClassNames: { line: { single: "dig-hp95xv2_21-7-0", multiple: "dig-hp95xv3_21-7-0" }, isTail: { true: "dig-hp95xv4_21-7-0" }, isHidden: { true: "dig-hp95xv5_21-7-0" } }, defaultVariants: { line: "single", isTail: true, isHidden: true }, compoundVariants: [] });

// ../src/truncate/utils.tsx
import { splitGraphemes } from "unicode-segmenter/grapheme";

// ../src/_global/innerText.ts
var hasProps = (node) => Object.prototype.hasOwnProperty.call(node, "props");
var reduceNodeToString = (previous, current) => previous + innerText(current);
var innerText = (node) => {
  if (node === null || typeof node === "boolean" || typeof node === "undefined") {
    return "";
  }
  if (typeof node === "number") {
    return node.toString();
  }
  if (typeof node === "string") {
    return node;
  }
  if (Array.isArray(node)) {
    return node.reduce(reduceNodeToString, "");
  }
  if (hasProps(node) && Object.prototype.hasOwnProperty.call(node.props, "children")) {
    return innerText(node.props.children);
  }
  return "";
};

// ../src/truncate/utils.tsx
var ELLIPSIS = "\u2026";
var canvas = null;
var canvasContext = null;
var getCanvas = () => {
  if (canvas) return canvas;
  canvas = document.createElement("canvas");
  return canvas;
};
var getCanvasContext = (font) => {
  const canvas2 = getCanvas();
  if (canvas2) {
    if (!canvasContext) {
      canvasContext = canvas2.getContext("2d");
    }
    if (canvasContext) {
      canvasContext.font = font;
    }
    return canvasContext;
  } else {
    return null;
  }
};
var calculateTextWidth = (str, font) => {
  const canvasContext2 = getCanvasContext(font);
  if (canvasContext2) {
    const text = canvasContext2.measureText(str);
    return text.actualBoundingBoxRight + text.actualBoundingBoxLeft;
  } else {
    return 0;
  }
};
var truncateByLocation = (graphemes, maxLen, location) => {
  const preLen = Math.floor(maxLen * location);
  const newGraphemes = graphemes.slice(0, preLen);
  newGraphemes.push(ELLIPSIS);
  newGraphemes.push(...graphemes.slice(graphemes.length - (maxLen - preLen), graphemes.length));
  return newGraphemes.join("");
};
var truncateText = (str, availableWidth, location, font) => {
  const strWidth = calculateTextWidth(str, font);
  const graphemes = Array.from(splitGraphemes(str));
  if (strWidth <= availableWidth + 1 || graphemes.length <= 2) {
    return str;
  }
  let maxLen = Math.floor(availableWidth / strWidth * graphemes.length);
  let newStr;
  do {
    newStr = truncateByLocation(graphemes, maxLen, location);
    maxLen--;
  } while (calculateTextWidth(newStr, font) > availableWidth + 1 && maxLen > 1);
  return newStr;
};
var isTruncated = (triggerRef, midTruncated) => {
  if (!triggerRef || !triggerRef.current) return false;
  const cssTruncated = triggerRef.current.offsetWidth < triggerRef.current.scrollWidth || triggerRef.current.offsetHeight < triggerRef.current.scrollHeight;
  return cssTruncated || midTruncated;
};
var getFont = (element) => {
  if (element && window && window.getComputedStyle) {
    const style = window.getComputedStyle(element);
    const font = [
      style["fontWeight"],
      style["fontStyle"],
      style["fontSize"],
      style["fontFamily"]
    ].join(" ");
    return font;
  }
  return "";
};

// ../src/_global/resize_observer_polyfill.ts
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";
var polyfillResizeObserverGlobally = () => {
  if ("ResizeObserver" in globalThis === false) {
    globalThis.ResizeObserver = ResizeObserverPolyfill;
  }
};

// ../src/_global/useFontsReady.tsx
import { useIsomorphicLayoutEffect } from "@react-hookz/web";
import * as React from "react";
var useFontsReady = (callback, shouldRunOnFirstRun = false) => {
  const callbackRef = React.useRef(callback);
  callbackRef.current = callback;
  useIsomorphicLayoutEffect(() => {
    let shouldStillRun = true;
    if (shouldRunOnFirstRun === false && "document" in globalThis && "fonts" in document) {
      document.fonts.ready.then(() => {
        if (shouldStillRun) {
          callbackRef.current();
        }
      });
    } else {
      callbackRef.current();
    }
    return () => {
      shouldStillRun = false;
    };
  }, []);
};

// ../src/truncate/truncate.tsx
polyfillResizeObserverGlobally();
var isHtmlElement = (node) => node !== null && typeof node === "object" && node.nodeType === Node.ELEMENT_NODE;
var VisibleTruncatedText = ({ truncatedText }) => {
  return /* @__PURE__ */ React2.createElement(React2.Fragment, null, truncatedText);
};
var VisibleTruncatedTextMemo = React2.memo(VisibleTruncatedText);
var calcParentSpace = (parentEl, truncateEl, maxWidth) => {
  let acc = parentEl.clientWidth;
  if (window && window.getComputedStyle) {
    const style = window.getComputedStyle(parentEl);
    const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    acc -= padding;
  }
  parentEl.childNodes.forEach((child) => {
    if (child !== truncateEl && isHtmlElement(child)) {
      let childWidth = child.getBoundingClientRect().width;
      if (window && window.getComputedStyle) {
        const style = window.getComputedStyle(child);
        childWidth += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
      }
      acc -= childWidth;
    }
  });
  return maxWidth && maxWidth < acc ? maxWidth : acc;
};
var Truncate = ({
  children,
  className,
  lines = 1,
  location = 1,
  maxWidth,
  style,
  tooltipControlProps,
  alwaysShowTooltip = false,
  observeParent = false,
  onBeforeTruncateChange,
  onTooltipShown,
  ...rest
}) => {
  const isSingleLine = lines <= 1;
  const isTailTruncate = location === 1;
  const [showTooltip, setShowTooltip] = React2.useState(false);
  const [midTruncated, setMidTruncated] = React2.useState(false);
  const [truncatedText, setTruncatedText] = React2.useState(innerText(children));
  const triggerRef = React2.useRef(null);
  const [isRunningUpdate, setIsRunningUpdate] = React2.useState(true);
  const [nodeElement, setNodeElement] = React2.useState(null);
  const parentEl = React2.useMemo(() => {
    if (nodeElement) {
      return nodeElement.parentElement;
    }
    return null;
  }, [nodeElement]);
  const isUsingCanvasCalculation = !isTailTruncate || !!onBeforeTruncateChange;
  const [font, setFont] = React2.useState("");
  const cls = classNames("dig-Truncate", truncate, className);
  const clsInner = classNames(
    {
      "dig-Truncate--singleLine": isSingleLine,
      "dig-Truncate--multipleLine": !isSingleLine,
      "dig-Truncate--tail": isTailTruncate,
      "dig-Truncate--hidden": isRunningUpdate
    },
    truncateInner({
      line: isSingleLine ? "single" : "multiple",
      isTail: isTailTruncate,
      isHidden: isRunningUpdate
    })
  );
  const innerTextMemo = React2.useMemo(() => {
    return innerText(children);
  }, [children]);
  const update = React2.useCallback(() => {
    if (!isUsingCanvasCalculation) {
      setIsRunningUpdate(false);
      return;
    }
    if (!nodeElement || !font) return;
    const calcLocation = location > 1 ? 1 : location < 0 ? 0 : location;
    setIsRunningUpdate(true);
    const availableSpace = observeParent && parentEl ? calcParentSpace(parentEl, nodeElement, maxWidth) : nodeElement.getBoundingClientRect().width;
    const localTruncatedText = truncateText(innerTextMemo, availableSpace, calcLocation, font);
    const localMidTruncated = localTruncatedText !== innerTextMemo;
    if (onBeforeTruncateChange) {
      onBeforeTruncateChange({ current: localTruncatedText, original: innerTextMemo });
    }
    setTruncatedText(localTruncatedText);
    setMidTruncated(localMidTruncated);
    setIsRunningUpdate(false);
  }, [
    nodeElement,
    location,
    observeParent,
    parentEl,
    maxWidth,
    innerTextMemo,
    onBeforeTruncateChange,
    font,
    isUsingCanvasCalculation
  ]);
  React2.useEffect(() => {
    update();
  }, [update, children]);
  const updateIfResizeObserverEntry = useDebouncedCallback(
    (entry) => {
      if (!entry) return;
      update();
    },
    [innerTextMemo, location, nodeElement, update],
    10
  );
  useFontsReady(() => {
    const font2 = getFont(nodeElement);
    setFont(font2);
    update();
  });
  useResizeObserver(nodeElement && observeParent ? parentEl : null, updateIfResizeObserverEntry);
  useResizeObserver(nodeElement, updateIfResizeObserverEntry);
  const styles = {
    ...style,
    maxWidth
  };
  const handleMouseOverOrEnter = React2.useCallback(() => {
    if (!triggerRef.current) {
      setShowTooltip(false);
      return;
    }
    if ((alwaysShowTooltip || // Check whether text is truncated
    isTruncated(triggerRef, midTruncated)) && !showTooltip) {
      onTooltipShown && onTooltipShown({ current: truncatedText, original: innerTextMemo });
      setShowTooltip(true);
    }
  }, [
    triggerRef,
    alwaysShowTooltip,
    midTruncated,
    showTooltip,
    onTooltipShown,
    truncatedText,
    innerTextMemo
  ]);
  const handleMouseLeave = () => setShowTooltip(false);
  const tooltipOpenControl = tooltipControlProps && typeof tooltipControlProps.open === "boolean" ? tooltipControlProps.open : showTooltip;
  return /* @__PURE__ */ React2.createElement(React2.Fragment, null, tooltipControlProps && /* @__PURE__ */ React2.createElement(
    Tooltip.Control,
    {
      children,
      ...tooltipControlProps,
      triggerRef,
      open: tooltipOpenControl
    }
  ), /* @__PURE__ */ React2.createElement(
    "div",
    {
      className: cls,
      style: styles,
      ref: (el) => {
        setNodeElement(el);
      },
      ...rest
    },
    /* @__PURE__ */ React2.createElement(
      "div",
      {
        className: clsInner,
        style: { WebkitLineClamp: lines > 1 ? lines : void 0 },
        ref: triggerRef,
        "data-testid": "digTruncateTooltipTrigger",
        onMouseOver: handleMouseOverOrEnter,
        onMouseEnter: handleMouseOverOrEnter,
        onMouseLeave: handleMouseLeave
      },
      isSingleLine && (typeof onBeforeTruncateChange === "function" || !isTailTruncate) ? /* @__PURE__ */ React2.createElement(VisibleTruncatedTextMemo, { truncatedText }) : innerTextMemo
    )
  ));
};
Truncate.displayName = "Truncate";
export {
  Truncate
};
